import React, { useEffect } from "react";
import { PostPaywallProps } from "@/types/modules/post/components";
import { BaseButton } from "@/components/ui-kit/Buttons/BaseButton";
import { ButtonType } from "@/types/ui-kit/buttons";
import Image from "next/image";
import { useAuthUrls } from "@/hooks/useAuthUrls";
import useScrollingRect from "@/hooks/useScrollingRect";
import { pushToDataLayer } from "@/utils/pushToDataLayer";

export const PostPaywallGuestContent: React.FC<PostPaywallProps> = ({ postId }) => {
  const { getLoginUrl, getRegisterUrl } = useAuthUrls();
  const isCurrentSection = useScrollingRect("postPaywallGuestContent", 52);

  useEffect(() => {
    if (isCurrentSection) {
      pushToDataLayer({
        event: "article_interaction",
        interaction_type: "content_consumed",
      });
    }
  }, [isCurrentSection]);

  const openAuthUrl = (interaction: string, urlCallback: (params?: QueryParam[]) => string) => {
    pushToDataLayer({
      event: "article_interaction",
      interaction_type: "click_cta",
      interaction_option: interaction,
    });

    window.location.href = urlCallback([{ key: "scrollY", value: "1" }]);
  };

  return (
    <div
      className="relative w-full before:absolute before:bottom-full before:h-[200px] before:w-full before:bg-gradient-to-t before:from-white dark:before:from-dark"
      id="postPaywallGuestContent"
    >
      <div className="mx-auto flex max-w-[500px] flex-col items-center justify-center text-center">
        <div className="mb-[24px] flex h-[64px] w-[64px] items-center justify-center">
          <Image src="/assets/images/icons/paywall-icon.svg" width={64} height={64} alt="Paywall icon" />
        </div>
        <h3 className="mb-2 font-mercury text-3xl font-semibold dark:text-white">Dočtěte celý článek zdarma</h3>
        <p className="font-sm font-sans font-light text-dark dark:text-white">
          Vytvořte si účet, získáte tak 3 libovolné články k přečtení zdarma.
        </p>
        <div className="mx-auto mt-[20px] flex w-full max-w-[280px] flex-col">
          <div className="overflow-hidden rounded-full">
            <BaseButton
              title="Vytvořit nový účet"
              type={ButtonType.Primary}
              onClick={() => openAuthUrl("Vytvořit nový účet", getRegisterUrl)}
              component="button"
              fullWidth
            />
          </div>
        </div>
        <p className="font-sm my-[20px] font-sans font-light text-dark dark:text-white">
          Pokud už registraci nebo předplatné máte, přihlaste se.
        </p>
        <div className="mx-auto flex w-full max-w-[280px] flex-col">
          <div className="overflow-hidden rounded-full">
            <BaseButton
              title="Přihlásit se"
              type={ButtonType.TransparentStroked}
              onClick={() => openAuthUrl("Přihlásit se", getLoginUrl)}
              component="button"
              fullWidth
            />
          </div>
        </div>
      </div>
    </div>
  );
};
